import { render, staticRenderFns } from "./CheckBoxGroupView.vue?vue&type=template&id=6b74c3fa&scoped=true"
import script from "./CheckBoxGroupView.vue?vue&type=script&lang=js"
export * from "./CheckBoxGroupView.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxGroupView.vue?vue&type=style&index=0&id=6b74c3fa&prod&lang=scss"
import style1 from "./CheckBoxGroupView.vue?vue&type=style&index=1&id=6b74c3fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b74c3fa",
  null
  
)

export default component.exports